import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 w-full group relative" }
const _hoisted_2 = { class: "flex flex-wrap items-center gap-1 p-1 bg-zinc-900/50 border border-zinc-800 rounded-t-md border-b-0 transition-colors group-focus-within:border-primary/50" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "absolute top-full left-0 mt-1 z-50 shadow-xl"
}
const _hoisted_5 = {
  key: 0,
  class: "h-4 w-px bg-zinc-800 mx-1"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["placeholder", "rows"]

import { ref, type HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { useVModel } from '@vueuse/core'
import { Bold, Italic, Strikethrough, Code, Smile, EyeOff } from 'lucide-vue-next'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import EmojiPicker from 'vue3-emoji-picker'
import 'vue3-emoji-picker/css'


export default /*@__PURE__*/_defineComponent({
  __name: 'RichTextarea',
  props: {
    class: {},
    defaultValue: {},
    modelValue: {},
    placeholder: {},
    rows: {},
    variables: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const textareaRef = ref<HTMLTextAreaElement | null>(null)
const showEmojiPicker = ref(false)

const applyFormat = (tag: string, endTag?: string) => {
  const textarea = textareaRef.value
  if (!textarea) return

  const start = textarea.selectionStart
  const end = textarea.selectionEnd
  const text = String(modelValue.value || '')
  const selectedText = text.substring(start, end)
  
  const actualEndTag = endTag || tag.replace('<', '</')
  const newText = text.substring(0, start) + tag + selectedText + actualEndTag + text.substring(end)
  
  modelValue.value = newText
  
  setTimeout(() => {
    textarea.focus()
    if (selectedText.length === 0) {
      const newPos = start + tag.length
      textarea.setSelectionRange(newPos, newPos)
    } else {
      const newPos = start + tag.length + selectedText.length + actualEndTag.length
      textarea.setSelectionRange(newPos, newPos)
    }
  }, 0)
}

const insertText = (content: string) => {
  const textarea = textareaRef.value
  if (!textarea) return

  const start = textarea.selectionStart
  const end = textarea.selectionEnd
  const text = String(modelValue.value || '')
  
  const newText = text.substring(0, start) + content + text.substring(end)
  modelValue.value = newText
  
  setTimeout(() => {
    textarea.focus()
    const newPos = start + content.length
    textarea.setSelectionRange(newPos, newPos)
  }, 0)
}

const onEmojiSelect = (emoji: any) => {
  insertText(emoji.i)
  showEmojiPicker.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TooltipProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (applyFormat('<b>', '</b>'))),
                    type: "button",
                    class: "p-1.5 rounded hover:bg-white/10 text-zinc-400 hover:text-white transition-colors"
                  }, [
                    _createVNode(_unref(Bold), { class: "size-4" })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(TooltipContent), { side: "top" }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Negrito")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TooltipProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (applyFormat('<i>', '</i>'))),
                    type: "button",
                    class: "p-1.5 rounded hover:bg-white/10 text-zinc-400 hover:text-white transition-colors"
                  }, [
                    _createVNode(_unref(Italic), { class: "size-4" })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(TooltipContent), { side: "top" }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Itálico")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TooltipProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (applyFormat('<s>', '</s>'))),
                    type: "button",
                    class: "p-1.5 rounded hover:bg-white/10 text-zinc-400 hover:text-white transition-colors"
                  }, [
                    _createVNode(_unref(Strikethrough), { class: "size-4" })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(TooltipContent), { side: "top" }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Riscado")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TooltipProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (applyFormat('<code>', '</code>'))),
                    type: "button",
                    class: "p-1.5 rounded hover:bg-white/10 text-zinc-400 hover:text-white transition-colors"
                  }, [
                    _createVNode(_unref(Code), { class: "size-4" })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(TooltipContent), { side: "top" }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("Monoespaçado")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TooltipProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (applyFormat('<tg-spoiler>', '</tg-spoiler>'))),
                    type: "button",
                    class: "p-1.5 rounded hover:bg-white/10 text-zinc-400 hover:text-white transition-colors",
                    title: "Spoiler"
                  }, [
                    _createVNode(_unref(EyeOff), { class: "size-4" })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(TooltipContent), { side: "top" }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Spoiler")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(TooltipProvider), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
              default: _withCtx(() => [
                _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showEmojiPicker.value = !showEmojiPicker.value)),
                      type: "button",
                      class: _normalizeClass(_unref(cn)('p-1.5 rounded hover:bg-white/10 transition-colors', showEmojiPicker.value ? 'bg-white/10 text-primary' : 'text-zinc-400 hover:text-white'))
                    }, [
                      _createVNode(_unref(Smile), { class: "size-4" })
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TooltipContent), { side: "top" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Emojis")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (showEmojiPicker.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(EmojiPicker), {
                native: true,
                theme: "dark",
                onSelect: onEmojiSelect,
                class: "!bg-zinc-900 !border-zinc-800"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.variables?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variables, (variable) => {
        return (_openBlock(), _createBlock(_unref(TooltipProvider), {
          key: variable.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
              default: _withCtx(() => [
                _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (insertText(variable.value)),
                      type: "button",
                      class: "px-2 py-1 text-[10px] uppercase font-bold text-zinc-500 hover:text-primary transition-colors hover:bg-primary/5 rounded border border-transparent hover:border-primary/20"
                    }, _toDisplayString(variable.label), 9, _hoisted_6)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(TooltipContent), { side: "top" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Inserir " + _toDisplayString(variable.label), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("textarea", {
      ref_key: "textareaRef",
      ref: textareaRef,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
      placeholder: props.placeholder,
      rows: props.rows || 3,
      class: _normalizeClass(_unref(cn)('flex min-h-20 w-full rounded-b-md border border-zinc-800 bg-white/5 px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/50 disabled:cursor-not-allowed disabled:opacity-50 text-white transition-colors', props.class))
    }, null, 10, _hoisted_7), [
      [_vModelText, _unref(modelValue)]
    ]),
    (showEmojiPicker.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (showEmojiPicker.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})